import React from 'react';
import { useQuery } from '@apollo/client';
import { Field } from 'formik';
import ReactSelect from 'components/Fields/ReactSelect';
import Loader from 'components/common/Loader';
import { PRODUCT_LIST } from 'pages/Products/ProductsGraphQL';

const ProductSelectField = ({ required = false, isDisabled = false }) => {
  const { data, loading, error } = useQuery(PRODUCT_LIST, {
    variables: {
      filter: [],
      // pageNo: 0,
      // pageSize: 30,
      // sortCol: null,
      // sortDirection: null,
      pagination: false,
    },
    fetchPolicy: 'network-only',
  });

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <div>
      <Field
        name="product"
        label="Product"
        type="select"
        component={ReactSelect}
        data={data?.productList?.productList}
        keys={{ id: 'id', label: 'label' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.name}
        required={required}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default ProductSelectField;
